export default "__VITE_ASSET__DaQp5XHK__"